import request from '@/utils/request';
import { API_PREFIX, API_PATHS } from '@/config/api';
import qs from 'qs';

// 登录API
export function login(data) {
  // 检查是否直接传入了数字形式的角色ID（题库系统的情况）
  let role_id;
  if (!isNaN(parseInt(data.role))) {
    role_id = parseInt(data.role);
    console.log('使用数字形式的角色ID:', role_id);
  } else {
    // 根据角色映射role_id
  switch (data.role) {
    case 'admin':
      role_id = 2;
      break;
    case 'teacher':
      role_id = 3;
      break;
    case 'parent':
      role_id = 4;
      break;
    case 'student':
      role_id = 5;
      break;
    default:
      role_id = 0;
  }
  }

  console.log('登录使用的role_id:', role_id);

  return request({
    url: API_PREFIX + API_PATHS.AUTH.LOGIN,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify({
      username: data.username,
      password: data.password,
      school_code: data.schoolCode || data.school_code,
      role_id: role_id
    })
  });
}

// 短信验证码登录API
export function smsLogin(data) {
  // 检查是否直接传入了数字形式的角色ID（题库系统的情况）
  let role_id;
  if (!isNaN(parseInt(data.role))) {
    role_id = parseInt(data.role);
    console.log('短信登录使用数字形式的角色ID:', role_id);
  } else {
    // 根据角色映射role_id
  switch (data.role) {
    case 'admin':
      role_id = 2;
      break;
    case 'teacher':
      role_id = 3;
      break;
    case 'parent':
      role_id = 4;
      break;
    case 'student':
      role_id = 5;
      break;
    default:
      role_id = 0;
  }
  }

  console.log('短信登录使用的role_id:', role_id);

  return request({
    url: API_PREFIX + '/auth/sms-login',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify({
      phone: data.phone,
      sms_code: data.smsCode,
      school_code: data.schoolCode || data.school_code,
      role_id: role_id
    })
  });
}

// 发送短信验证码
export function sendSmsCode(params) {
  // 兼容两种参数传递方式
  let phone, code_type;
  
  if (typeof params === 'object') {
    phone = params.phone;
    code_type = params.code_type || 'login';
  } else {
    // 向下兼容旧的参数方式
    phone = params;
    code_type = arguments[1] || 'login';
  }

  // 尝试从URL中获取campus_code
  let campus_code = '';
  const path = window.location.pathname;
  // 尝试匹配不同角色的URL模式
  const adminMatch = path.match(/\/([^\/]+)\/admin/);
  const teacherMatch = path.match(/\/([^\/]+)\/([^\/]+)\/teacher/);
  const parentMatch = path.match(/\/([^\/]+)\/([^\/]+)\/parent/);
  const studentMatch = path.match(/\/([^\/]+)\/([^\/]+)\/student/);
  
  if (adminMatch && adminMatch.length >= 2) {
    campus_code = adminMatch[1];
  } else if (teacherMatch && teacherMatch.length >= 3) {
    campus_code = teacherMatch[2];
  } else if (parentMatch && parentMatch.length >= 3) {
    campus_code = parentMatch[2];
  } else if (studentMatch && studentMatch.length >= 3) {
    campus_code = studentMatch[2];
  }
  
  // 如果URL中没有校区码，尝试从localStorage获取
  if (!campus_code) {
    campus_code = localStorage.getItem('campusCode') || '';
  }

  console.log('发送验证码参数:', { phone, code_type, campus_code });
  
  return request({
    url: API_PREFIX + '/public/sms/send',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      phone,
      code_type,
      campus_code  // 添加校区代码到请求体
    }
  });
}

// 注册API
export function register(data) {
  return request({
    url: API_PREFIX + API_PATHS.AUTH.REGISTER,
    method: 'post',
    data
  });
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: API_PREFIX + API_PATHS.AUTH.USER_INFO,
    method: 'get'
  });
}

// 登出
export function logout() {
  return request({
    url: API_PREFIX + API_PATHS.AUTH.LOGOUT,
    method: 'post'
  });
}

// 获取校区列表
export function getCampusList(params) {
  console.log('获取校区列表接口');
  console.log('API路径:', API_PREFIX + API_PATHS.CAMPUS.LIST);
  console.log('查询参数:', params);
  
  return request({
    url: API_PREFIX + API_PATHS.CAMPUS.LIST,
    method: 'get',
    params
  }).then(response => {
    console.log('获取校区列表成功:', response);
    return response;
  }).catch(error => {
    console.error('获取校区列表失败:', error);
    // 返回模拟数据用于开发
    console.log('返回模拟校区列表数据');
    return [
      { id: 1, campus_code: 'CAM0001', campus_name: '总校区', address: '北京市海淀区中关村大街1号', contact_phone: '010-12345678' },
      { id: 2, campus_code: 'CAM0002', campus_name: '东校区', address: '北京市朝阳区建国路2号', contact_phone: '010-87654321' },
      { id: 3, campus_code: 'CAM0003', campus_name: '南校区', address: '北京市丰台区丰台路3号', contact_phone: '010-23456789' }
    ];
  });
}

// 选择校区
export function selectCampus(campusId) {
  return request({
    url: API_PREFIX + API_PATHS.CAMPUS.SELECT,
    method: 'post',
    data: { campusId }
  });
} 